import {SubUserModelRepository} from '../repository/sub-user-model.repository';

export class SubUsersResponseModel {
    users: SubUserModelRepository[];

    constructor(obj) {
        this.users = obj.map((dt) => dt as SubUserModelRepository);
    }
}
